module.exports = __webpack_public_path__ + "static/media/ag-shop3.726993ed.jpg";